import React from 'react'
import clsx from 'clsx'

interface RichTextContentProps {
  html: string | null | undefined
  className?: string
  emptyText?: string
}

export const RichTextContent: React.FC<RichTextContentProps> = ({ html, className, emptyText = 'No content.' }) => {
  if (!html || !html.trim()) {
    return <p className={clsx('text-sm text-gray-500', className)}>{emptyText}</p>
  }

  return <div className={clsx('prose prose-sm max-w-none text-gray-700', className)} dangerouslySetInnerHTML={{ __html: html }} />
}